export default __webpack_public_path__ + "static/articlesImage-8424c95d1491dfc43ad14d3088c97fcb.webp";